import { Space, Spin } from "antd";
import React, { useEffect, useState } from "react";
import ContentHead from "../../components/Admin/Common/ContentHead";
import CustomeHeader from "../../components/Admin/Common/CustomeHeader";
import ViewButton from "../../components/Admin/Common/ViewButton";
import Button from "@mui/material/Button";
import {
  TablePagination,
} from "../../StyledComponents/Common";
import {
  TableTitle,
  TableTop,
} from "../../StyledComponents/CreateKeyAccountManager";
import { MainContainer } from "../../StyledComponents/Dashboard";
import { DeleteOutlined } from "@ant-design/icons";
// import { IconImg } from '../StyledComponents/Header'
import {
  ContentContainer,
} from "../../StyledComponents/RateManagement";
import { Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { authuser } from "../../store/Authentication/AuthSlice";
import { ExclamationCircleFilled  , WarningOutlined} from "@ant-design/icons";
// import { shortenString } from '../../functions/Utils'
import { FilterSection, SpinContainer } from "../../StyledComponents/Queries";
import TransportationTable from "../../components/Admin/Common/TransportationTable";
import AirlineDetailManagement from "../../components/Admin/AirlineScheduleManagement/AirlineDetailManagement";
import AddButton from "../../components/Admin/Common/AddButton";
import SearchBox from "../../components/Admin/Common/SearchBox";
import { getallairports } from "../../store/SearchRates/SearchRatesSlice";
import { airlines_list } from "../../store/Admin/Common/CommonSlice";
import RowSelectionTable from "../../components/Admin/Common/RowSelectionTable";
import { httpinstance } from "../../axios/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
let debounceTimer = null;
function AirlineScheduleManagement(props) {
  const dispatch = useDispatch();
  const loginedUser = useSelector(authuser);
  const userroles = loginedUser?.userroles;
  const [tabType, setTabType] = useState(
    userroles === "ocean_admin" ? "ocean" : "air"
  );
  const [pageType, setPageType] = useState("table");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [instance, setInstance] = useState({});
  const [type, setType] = useState("view");
  const [data, setData] = useState([]);
  const [, setCallList] = useState(true);
  const [loading, setLoading] = useState(true);
  const [airPort, setAirPort] = useState([]);
  const [airLineList, setairLineList] = useState([]);
  const [selectedUsers, setSelectUser] = useState([])
  // const [isEditing, setIsEditing] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  useEffect(() => {
    // if (data.length > 0) {
    //   setFilteredData(
    //     data.filter(
    //       (item) => item?.carrier?.carr_code === props?.data?.carr_code
    //     )
    //   );
    // }
    // 
    getAllFlightSchedulefiltered()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);//data, props?.data?.carr_code
    console.log(props?.data,"data")
  const getAllFlightSchedulefiltered = async () => {
    try {
      // 
      console.log(props,"hi")
      const airlineName = props?.data?.airline; // "AIR INDIA"
const origin = props?.data?.origin_port;  // "DEL"
const destination = props?.data?.destination_port;  // "JFK"
const flightId = props?.data?._id;
const decodedUrl = decodeURIComponent(`/flight-schedule/by-aod/${flightId}?airlineName=${airlineName}&origin=${origin}&destination=${destination}`);

console.log("Request URL:", decodedUrl); // Debugging to check the final URL

      const response = await httpinstance.get(decodedUrl);
      console.log("response", response?.data?.data);
      setFilteredData(response?.data?.data);
      const selectedIds = response?.data?.data?.filter(item => item.checked) // Only include items that are checked
      .map(item => item._id); // Get their IDs

    setSelectUser (selectedIds); // Update selected users

      // console.log("")
      // setData(response?.data?.data)
      // setSelectUser([]);
    } catch (err) {}
  };
  const { confirm } = Modal;
  console.log(selectedUsers, "selectedUsers");
  // const handleEditClick = () => {
  //   setIsEditing(true);U
  // };
  // console.log("data123", data);
  // const handleCancelClick = () => {
  //   console.log("Cancel clicked");
  //   setIsEditing(false);
  //   setSelectUser([]);
  // };
  // const saveAllFlightSchedule = async (payload) => {
  //   try {
  //     const response = await httpinstance.post(`manual`, payload);
  //     // setData(response?.data?.data);
  //     console.log("response", response);
  //     if (response?.status === 200) {
  //       toast.success(response?.data?.message, {
  //         position: "top-center",
  //         autoClose: 3000,
  //         hideProgressBar: true,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //         // theme: "colored",
  //       });
  //       setSelectUser([]);
  //     }
  //     // setScheduleSaveData
  //   } catch (err) {
  //     toast.error(err?.message || "Something went wrong!", {
  //       position: "top-center",
  //       autoClose: 3000,
  //       hideProgressBar: true,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       // theme: "colored",
  //     });
  //   }
  // };
  // useEffect(() => {
  //   // If props.data has selected_flight_ids, use those as the initial selection
  //   if (props?.data?.selected_flight_ids?.length) {
  //     setSelectUser(props.data.selected_flight_ids)
  //   } else {
  //     // Reset selection when filtered data changes and no selection exists
  //     setSelectUser([])
  //   }
  // }, [props?.data?.selected_flight_ids, filteredData])

  const updatedata=async(payload)=>{
    try {
      // const url=`https://freightsee-backend.sgate.net/api/update/67dd41ad4772ed3c617d6f5b`
      const response = await httpinstance.put(`update/${props?.data?._id}`,payload);
      console.log("response", response);
      if (response?.status === 200) {
        toast.success(response?.data?.message, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          // theme: "colored",
        });
        // setSelectUser([]);
        setPageType("table");
      }
      
    }catch (err) {
      console.log(err)
       toast.error(err?.message || "Something went wrong!", {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              // theme: "colored",
            });
      
    }
  }
  const handleSaveClick = () => {
  
    const updatedData = {
      ...props.data,
      selected_flight_ids: selectedUsers,
      customType: "Air", // Update selected_flight_ids
  };
  updatedata(updatedData);
    // setIsEditing(false);
  };

  // const handleRowSelect = (row) => {
  //   if (isEditing) {
  //     setSelectUser(row);
  //   }
  // };

  useEffect(() => {
    getAllFlightSchedule();

    dispatch(airlines_list()).then((res) => {
      setairLineList(
        res?.payload?.data?.data.map((item) => ({
          airlineName: item?.carr_name,
          label: item?.carr_code,
          value: item?._id,
        }))
      );
    });

    dispatch(getallairports()).then((res) => {
      setAirPort(
        res?.payload?.data?.data?.map((item) => ({
          value: `${item.cityName} - (${item.code})`,
          label: `${item.cityName} - (${item.code})`,
        }))
      );
      setLoading(false);
    });
  }, [pageType, dispatch]);

  const getAllFlightSchedule = async (queryParams = "") => {
    try {
      const response = await httpinstance.get(`flight-schedule${queryParams}`);
      setData(response?.data?.data);
      // setSelectUser([]);
    } catch (err) {}
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  }
  // };
  // useEffect(() => {
  //   if (filteredData.length > 0 && props?.data?.selected_flight_ids?.length) {
  //     // Only set selected IDs that actually exist in the filtered data
  //     const validSelections = props?.data?.selected_flight_ids?.filter((id) =>
  //       filteredData.some((item) => item._id === id),
  //     )
  //     console.log("validSelections", validSelections)
  //     setSelectUser(validSelections)
  //   }
  // }, [filteredData, props?.data?.selected_flight_ids])
  // useEffect(() => {
  //   if (filteredData.length > 0 && props?.data?.selected_flight_ids?.length) {
  //     const validSelections = props.data.selected_flight_ids.filter((id) =>
  //       filteredData.some((item) => item._id === id),
  //     );
  //     console.log("validSelections", validSelections);
  //     setSelectUser (validSelections);
  //   } else {
  //     setSelectUser ([]); // Reset if no valid selections
  //   }
  // }, [filteredData, props?.data?.selected_flight_ids]);
  console.log(props, filteredData, "hi");
  const handlePageSizeChange = (current, size) => {
    setPageSize(size);
    setCurrentPage(1);
  };

  const handleView = (record) => {
    setInstance(record);
    setPageType("view_page");
    setType("view");
  };

  const handleAdd = (key) => {
    setInstance({});
    setPageType("view_page");
    setType("create");
  };

  const handleBack = () => {
    if (type === "edit") {
      confirm({
        title: "Do you want to exit?",
        icon: <ExclamationCircleFilled />,
        content: "Your changes will not be saved.",
        okButtonProps: {
          style: {
            backgroundColor: "#1890ff",
            borderColor: "#1890ff",
            borderRadius: "4px",
            color: "#fff",
          },
        },
        onOk() {
          setCallList(true);
          setPageType("table");
          setInstance({});
        },
        onCancel() {
          console.log("Cancel");
        },
        
      });
    } else {
      // setCallList(true)
      setPageType("table");
      setInstance({});
    }
  };
  

  const handleDeleteRecord = async (item) => {
    confirm({
      title: "Do you want delete this airline?",
      icon: <WarningOutlined />,
      okButtonProps: {
        style: {
          backgroundColor: "#1890ff",
          borderColor: "#1890ff",
          borderRadius: "4px",
          color: "#fff",
        },
      },
     async onOk() {
        try {
          await httpinstance.patch(`flight-schedule/${item?._id}`, {
            isActive: true,
          });
          setData((prev) => {
            return prev?.filter((data) => data?._id !== item?._id);
          });
        } catch (err) {}
      },
      onCancel() {
        console.log("Cancel");
      },
      maskClosable: true
    });
  };

  const multiwayFlight = (flight = []) => {
    return flight
      .map((item) => {
        const origin = item?.origin?.split("-")?.[1]?.replace(/[()]/g, "");
        const destination = item?.destination
          ?.split("-")?.[1]
          ?.replace(/[()]/g, "");
        return origin && destination ? `${origin}-${destination}` : null;
      })
      .filter(Boolean)
      .join(" , ");
  };

  const columns = [
    {
      title: "Airline",
      dataIndex: "airlineName",
    },
    {
      title: "Origin",
      dataIndex: "origin",
      render: (text, record, index) => {
        return text ? text?.split("-")?.[1]?.replace(/[()]/g, "") : "-";
      },
    },
    {
      title: "Desination",
      dataIndex: "destination",
      render: (text, record, index) => {
        return text ? text?.split("-")?.[1]?.replace(/[()]/g, "") : "-";
      },
    },
    {
      title: "Departure Days",
      dataIndex: "departuredays",
      render: (text, record, index) => {
        return text ? text?.map((item) => item?.toUpperCase()).join(",") : "-";
      },
    },
    {
      title: "Departure Time",
      dataIndex: "departureTime",
      render: (text, record, index) => {
        return text ? text : "-";
      },
    },
    {
      title: "Routing",
      dataIndex: "itinerary",
      render: (text, record, index) => {
        return text?.length === 1 ? "Direct" : multiwayFlight(text);
      },
    },
    {
      title: "LAT",
      dataIndex: "lat",
    },
    {
      title: "TAO",
      dataIndex: "tao",
    },
    {
      title: "Action",
      dataIndex: "action",
      className: "text-right",
      render: (text, record, index) => {
        return (
          <Space>
            <ViewButton handleClick={() => handleView(record)} data={record} />
            {!props?.activeButton && (
              <div className="icon_delete">
                <DeleteOutlined
                  onClick={() => handleDeleteRecord(record)}
                  style={{ cursor: "pointer" }}
                />
              </div>
            )}
          </Space>
        );
      },
    },
  ];

  const onSearch = (value) => {
    let queryStringObj = {};
    if (value?.length > 0) {
      queryStringObj["search"] = value;
    }
    let queryString = new URLSearchParams(queryStringObj).toString();
    queryString = queryString ? `?${queryString}` : "";
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(async () => {
      await getAllFlightSchedule(queryString);
    }, 700);
  };
  return (
    <>
    <section className="airlineSchedulesMain">
        {" "}
        <MainContainer>
          {!props?.activeButton && (
            <CustomeHeader
              title="Airline Schedules"
              description="Manage Airline Schedules"
            />
          )}
          {pageType === "table" ? (
            <>
            <div className="mt-4 tableResponsiveASAP"> 
              <ContentContainer>
                {!props?.activeButton && (
                  <TableTop>
                    <TableTitle>Manage Airline Schedules</TableTitle>
                    <FilterSection className="filter">
                      <SearchBox onSearch={onSearch} />
                      <AddButton title="Add Schedules" handleClick={handleAdd} />
                    </FilterSection>
                  </TableTop>
                 
                )}

                {loading ? (
                  <SpinContainer className="user-quote">
                    <Spin />
                  </SpinContainer>
                ) : !props?.activeButton ? (
                  <TransportationTable
                    name="flight_schedule_management"
                    currentPage={currentPage}
                    pageSize={pageSize}
                    columns={columns}
                    data={data}
                    rowKey="_id"
                    setCallList={setCallList}
                    scroll={true}
                    showScroll={true}
                  />
                ) : (
              <div>
                {/* {!isEditing && filteredData?.length <= 0 && (
                    <div className="border-t border-dashed border-gray-300 text-xl font-bold py-4">
                      No Flight Data Available
                      </div>
                )} */}
                    {/* {!isEditing  && filteredData?.length > 0 && (
                            <div className="border-t border-dashed border-gray-300 py-4">
                      <div className="flex justify-end space-x-4  ">
                        <Button
                          sx={{
                            color: "white",
                            backgroundColor: "#FFAF00",
                            "&:hover": {
                              backgroundColor: "black",
                            },
                          }}
                          onClick={handleEditClick}
                          disabled={isEditing}
                        >
                          Edit
                        </Button>
                      </div>
                      </div>
                    )} */}
                    {/* {isEditing && filteredData?.length > 0 && ( */}
                      <>
                        <div className="border-t border-dashed border-gray-300 py-4">
                          <div className="flex justify-between items-center w-full">
                            {/* Left Side - Text */}
                            <div className="text-xl font-bold">Select Flight Option</div>

                            {/* Right Side - Buttons */}
                            <div className="flex space-x-4">
                              <Button
                                sx={{
                                  color: "white",
                                  backgroundColor: "#FFAF00",
                                  "&:hover": { backgroundColor: "black" },
                                }}
                                onClick={handleSaveClick}
                              >
                                Save
                              </Button>
                              {/* <Button
                                sx={{
                                  color: "white",
                                  backgroundColor: "#FFAF00",
                                  "&:hover": { backgroundColor: "black" },
                                }}
                                onClick={handleCancelClick}
                              >
                                Cancel
                              </Button> */}
                            </div>
                          </div>
                        </div>
                      </>
                    {/* )} */}
                    <RowSelectionTable
                      currentPage={currentPage}
                      pageSize={pageSize}
                      columns={columns}
                      data={filteredData}
                      rowKey="_id"
                      setCallList={setCallList}
                      scroll={true}
                      showScroll={true}
                      setSelectArchive={setSelectUser}
                      checkedValues={selectedUsers}
                      // isEditing={isEditing}
                    />
                  </div>
                )}
              </ContentContainer>
                <div className="paginationCustom">
                  <TablePagination
                    style={{ marginTop: 16, marginBottom: "14px", textAlign: "center" }}
                    onChange={handlePageChange}
                    onShowSizeChange={handlePageSizeChange}
                    defaultCurrent={currentPage}
                    defaultPageSize={10}
                    total={filteredData?.length ? filteredData?.length : 10}
                    showSizeChanger={false}
                    showQuickJumper={false}
                  />
              </div>
             </div>
            </>
          ) : pageType === "view_page" ? (
            <ContentContainer>
              <ContentHead
                title="Add Airline Schedule"
                handleClick={() => handleBack()}
                border={false}
              />
              <AirlineDetailManagement
                type={type}
                instance={instance}
                setPageType={setPageType}
                setType={setType}
                setCallList={setCallList}
                tabType={tabType}
                setTabType={setTabType}
                airPort={airPort}
                airLineList={airLineList}
              />
            </ContentContainer>
          ) : null}
        </MainContainer>{" "}
        <ToastContainer />
    </section>
    </>
  );
}

export default AirlineScheduleManagement;
